import { companyDomainService } from "@/api/acendex/company";
import { apiUserInfo } from "@/api/acendex/user";
import { imageConfig } from "@/config/config";
import { useFetch } from "@/lib/fetch-tools";
import { styled } from "@/styles/stitches.config";
import { getText } from "@/utils/util";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Menu } from "../pc-header/menu";
import { Globe, Globe2 } from "lucide-react";

const MenuButton = styled("button", {
  width: "32px",
  height: "32px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "transparent",
  border: "none",
  cursor: "pointer",
  padding: 0,
});

const Drawer = styled("div", {
  position: "fixed",
  top: 0,
  right: 0,
  bottom: 0,
  width: "80%",
  maxWidth: "300px",
  background: "#F1F5F9",
  transform: "translateX(100%)",
  transition: "transform 0.3s ease-in-out",
  zIndex: 1001,
  padding: "20px",

  variants: {
    open: {
      true: {
        transform: "translateX(0)",
      },
    },
  },
});

const Overlay = styled("div", {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0, 0, 0, 0.5)",
  opacity: 0,
  visibility: "hidden",
  transition: "opacity 0.3s ease-in-out, visibility 0.3s ease-in-out",
  zIndex: 1000,

  variants: {
    open: {
      true: {
        opacity: 1,
        visibility: "visible",
      },
    },
  },
});

const CloseButton = styled("button", {
  position: "absolute",
  top: "20px",
  right: "20px",
  background: "transparent",
  border: "none",
  color: "#1E293B",
  fontSize: "24px",
  cursor: "pointer",
  padding: "4px",
});

const MenuContainer = styled("div", {
  marginTop: "60px",
  "& nav": {
    flexDirection: "column",
    gap: "20px",
  },
  "& a": {
    fontSize: "18px",
    padding: "12px",
    width: "100%",
    textAlign: "left",
  },
});

export function MobileHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const requestCompanyDomain = companyDomainService.useFetch({
    isInit: true,
  });
  const { data } = useFetch(apiUserInfo);
  const userInfo = data?.data;

  const { t: translate } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMenuOpen]);

  return (
    <>
      <div className="h-12 mx-2 flex justify-between items-center">
        <div
          data-v-4389a7cf=""
          className="flex justify-center items-center gap-4"
        >
          <img
            className="h-8 "
            src={
              imageConfig.baseImageUrl +
              requestCompanyDomain.data.value?.companyLogoName
            }
            alt={requestCompanyDomain.data.value?.companyName}
          />
        </div>
        <div className="flex items-center gap-1">
          <button
          className="mr-1"
            onClick={() => {
              navigate("/changelanguage");
            }}
          >
            <Globe />
          </button>
          {!userInfo && (
            <div className="flex justify-center items-center gap-4">
              <button
                onClick={() => {
                  navigate("/login");
                }}
                className="bg-primary rounded-md px-4 py-2 text-white"
              >
                {translate(getText("登錄"))}
              </button>
            </div>
          )}
          <MenuButton onClick={() => setIsMenuOpen(true)}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 12H21"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M3 6H21"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M3 18H21"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </MenuButton>
        </div>
      </div>

      <Overlay open={isMenuOpen} onClick={() => setIsMenuOpen(false)} />
      <Drawer open={isMenuOpen}>
        <CloseButton onClick={() => setIsMenuOpen(false)}>×</CloseButton>
        <MenuContainer>
          <Menu theme="light" />
        </MenuContainer>
      </Drawer>
    </>
  );
}
